import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader'
import { Link } from 'react-router-dom'
import axiosInstance from '../utils/api'

type Props = {}

const DownloadContent = (props: Props) => {
    const [loading, setLoading] = useState(false)
    const [contentList, setContentList] = useState<any>([])
    const [serialList, setSerialList] = useState<any>([])
    const [productList, setProductList] = useState<any>([])
    const [firmwareList, setFirmwareList] = useState<any>([])
    const [connectivityList, setConnectivityList] = useState<any>([])

    const [selectedSerial, setSelectedSerial] = useState<any>(0)
    const [selectedProduct, setSelectedProduct] = useState<any>(0)
    const [selectedFirmware, setSelectedFirmware] = useState<any>({
        id: 0,
        hmi: 0,
        firmware: 0, 
        telemetry: 0,
        remark: 0
    })
    const [selectedConnectivity, setSelectedConnectivity] = useState<any>(0)
    const [downloadLink, setDownloadLink] = useState<any>("")


    useEffect(() => {
        setContentList([])
        setProductList([])
        setSerialList([])
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/production/v1.0/page/download/content").then(res => {
            setLoading(false)
            console.log("res", res.data)
            for (let i in res.data.products) {
                for (let x in res.data.products[i]) {
                    if (res.data.products[i][x].remark == null) {
                        res.data.products[i][x].remark = "null"
                    }
                }
            }
            setContentList(res.data.products)

            setSerialList(res.data.serial)

            for (let key in res.data.products) {
                setProductList((prev:any) => [...prev, key])
            }
        }).catch (err => {
            setLoading(false)
            console.log("err", err)
        })
    }, [])
    
    function handleCreateSerial() {
        console.log(selectedSerial)
        console.log(selectedFirmware)
        console.log(selectedConnectivity)
        setLoading(true)
        axiosInstance.post(`https://api.cl-ds.com/internal/production/v2.0/download/content/`, {
            command: "downlaod_content",
            serial: selectedSerial,
            hmi: selectedFirmware.id,
            connectivity: selectedConnectivity
        }).then(res => {
            setLoading(false)
            console.log("res", res)
            setDownloadLink(res.data.URL)
        }).catch (err => {
            setLoading(false)
            console.log("err", err)
            alert("Server Error")
        })
    }

    function handleChangeProduct(value: string) {
        // console.log("handleChangeProduct", contentList, value)

        setSelectedProduct(value)
        setFirmwareList(contentList[value])
        setSelectedFirmware({ id: 0, hmi: 0, firmware: 0, telemetry: 0, remark: 0 })
        setConnectivityList([])
        setSelectedConnectivity(0)
    }

    function handleChangeFirmware(event: any) {
        const selectedIndex = event.target.options.selectedIndex
        // console.log("handleChangeFirmware", contentList, event.target.options[selectedIndex].getAttribute('data-key'))
        const id = event.target.options[selectedIndex].getAttribute('data-key')
        for (let product of contentList[selectedProduct]) {
            if (product.id == id) {
                setSelectedFirmware(product)
                if (product.connectivity && product.connectivity.length > 0) {
                    setConnectivityList(product.connectivity)
                }
            }
        }
    }

    function handleConnectivityChange(event: any) {
        // console.log("handleConnectivityLits", event.target.value)
        setSelectedConnectivity(event.target.value)
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                <div style={{float: "right", margin: "1rem", marginLeft: 0, marginBottom: 0}}>
                    <Link to={`/`} className="nav-link collapsed">
                        <button type="button" className="btn btn-outline-secondary">Back</button>
                    </Link>
                </div>
                <h5 className="card-title">Download Content</h5>

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Product</label>
                        <div className="col-sm-8">
                            <select className="form-select" aria-label="select" value={selectedProduct} onChange={(e)=>{ handleChangeProduct(e.target.value) }}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {productList.map((list:any, index: number) => (
                                    <option value={list} key={index}>{list}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    
                    
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Serial</label>
                        <div className="col-sm-8">
                            <select className="form-select" aria-label="select" value={selectedSerial} onChange={(e)=>{setSelectedSerial(e.target.value)}}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {serialList.map((list:any, index: number) => (
                                    <option value={list} key={index}>{list}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">HMI / Firmware / Telemetry</label>
                        <div className="col-sm-8">
                            <select className="form-select" aria-label="select" value={selectedFirmware.id} onChange={(e)=>{handleChangeFirmware(e)}}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {firmwareList.map((list:any) => (
                                    <option value={list.id} key={list.id} data-key={list.id}>{list.hmi} / {list.firmware} / {list.telemetry}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Connectivity</label>
                        <div className="col-sm-8">
                            <select className="form-select" aria-label="select" value={selectedConnectivity} onChange={(e)=>{handleConnectivityChange(e)}}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {connectivityList.map((list:any, index: number) => (
                                    <option value={list} key={index}>{list}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                                        
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Remark</label>
                        <div className="col-sm-8">
                            <input type="text" className="form-control" value={selectedFirmware.remark} disabled/>
                        </div>
                    </div>

                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleCreateSerial()}>Download</button>
                    </div>


                    <div className="row mt-3">
                        <div className="col-sm-12">
                            {downloadLink != "" && (
                                <>
                                <p>Please download here:</p>
                                <a href={downloadLink} target="_blank" >{downloadLink}</a>
                                </>
                            )}
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default DownloadContent